var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeOff = function SvgEyeOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.386 6.384c.4.623.615 1.21.615 1.615 0 1.333-2.334 4.666-6 4.666a5.95 5.95 0 0 1-.837-.058m4.365-8.137c-.95-.663-2.144-1.138-3.528-1.138-3.667 0-6 3.333-6 4.667 0 .83.904 2.435 2.471 3.528M11.53 4.47l3.138-3.138M11.53 4.47 9.415 6.584m-4.943 4.943-3.138 3.138m3.138-3.138 2.114-2.114m0 0a2 2 0 1 1 2.828-2.828M6.587 9.412l2.829-2.829"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeOff);
export default ForwardRef;